module.exports = __webpack_public_path__ + "img/3Dian5_6.73932ec8.png";